<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="seatmap-legends-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head06">
      <h1
        id="seatmap-legends-modal-title"
        class="p-modal-head06__title"
        innerHTML="{{ 'label.legend' | staticMsg }}"
      ></h1>
      <button id="servicing-seatmap-legends-modal-close" class="p-modal-head06__close js-modal-close" (click)="close()">
        <span class="u-visually-hidden" innerHTML="{{ 'label.close' | staticMsg }}"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="[lmodalBodyClass]">
    <div class="p-modal-body09">
      <div
        class="l-carousel01 l-carousel01--in-modal-body09"
        attr.aria-label="{{ 'reader.carouselTitle' | staticMsg }}"
      >
        <div class="l-carousel01__view">
          <div class="l-carousel01__wrap">
            <div class="l-carousel01__inner servicing-seatmap-legends-panel--scroll" id="carousel-contents">
              <button
                *ngIf="!isLeftEnd"
                id="servicing-seatmap-legends-modal-prev"
                class="l-carousel01__arrow l-carousel01__arrow--prev is-available"
                [attr.aria-label]="'alt.switchToPreviousLegends' | staticMsg"
                (click)="onClickLeftCarousel()"
              >
                <img
                  src="assets/images/btn_arrow_circle_left_40.svg"
                  width="36"
                  height="36"
                  alt="{{ 'alt.switchToPreviousLegends' | staticMsg }}"
                  aria-hidden="true"
                />
              </button>

              <!-- カルーセルで表示するコンテンツ -->
              <div class="p-modal-seatmap-legend-panel">
                <!-- カルーセルコンテンツ -->
                <div
                  #panelItem
                  class="p-modal-seatmap-legend-panel__item"
                  *ngFor="let legendRow of legendMatrix; let i = index"
                  id="carousel-item"
                  role="group"
                  attr.aria-label="{{
                    'm_static_message-reader.carouselNo' | staticMsg : { '0': legendMatrix.length, '1': i + 1 }
                  }}"
                  [attr.aria-hidden]="areChildrenInView(i)?.ariaHidden"
                  [attr.tabindex]="areChildrenInView(i)?.tabIndex"
                >
                  <div class="p-modal-seatmap-legend-panel__row" *ngFor="let legendInfo of legendRow">
                    <span class="p-modal-seatmap-legend-panel__row-icon">
                      <img *ngIf="legendInfo.imageUrl" src="{{ legendInfo.imageUrl }}" alt="" width="24" height="24" />
                    </span>
                    <span
                      class="p-modal-seatmap-legend-panel__row-label"
                      innerHTML="{{ legendInfo.staticMessageKey | staticMsg }}"
                    ></span>
                  </div>
                </div>
                <!-- //カルーセルコンテンツ -->
              </div>
              <!-- //カルーセルで表示するコンテンツ -->

              <button
                *ngIf="!isRightEnd"
                id="servicing-seatmap-legends-modal-next"
                class="l-carousel01__arrow l-carousel01__arrow--next is-available"
                [attr.aria-label]="'alt.switchToNextLegends' | staticMsg"
                (click)="onClickRightCarousel()"
              >
                <img
                  src="assets/images/btn_arrow_circle_right_40.svg"
                  width="36"
                  height="36"
                  alt="{{ 'alt.switchToNextLegends' | staticMsg }}"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
